import {Deserializable} from "./deserializable.model";

export class SubjectInvoiceItem {


invoice_item_id?: number;
invoice_id?: number;
invoice_number?: string;
billing_task_id?: number;
subject_billing_item_id?: number;
billing_task_name?: string;
myob_tax_code_id?: number;
myob_account_code_id?: number;
billing_task_fee?: any;
billing_task_description?: string;
subject_id?: number;
subject_number?: string;
job_id?: number;
job_number?: string;
qty?: any;
unit_price?: any;
tax?: any;
total?: any;

myob_id?
myob_array?;
// MYOB Variable inclsions
RowID?;
Type?;
Description?;
UnitOfMeasure?;
UnitCount?;
UnitPrice?;
UnitPriceForeign?;
DiscountPercent?;
Total?;
TotalForeign?;
AccountUID?;
JobUID?;
TaxCodeUID?;
TaxCodeCode?;
RowVersion?;

is_bulk?;

brand_id?: number;



  // ? what does this really do? (no encoding or deserialisation required...)
  // deserialize(input: any): SubjectInvoiceItem {
  //   Object.assign(this, input);

  //   return this;
  // }

  /*
invoice_item_id
invoice_id
billing_task_id
subject_billing_item_id
billing_task_name
myob_tax_code_id
myob_account_code_id
billing_task_fee
billing_task_description
subject_id
subject_number
job_id
job_number
qty
unit_price
tax
total
invoice_number
  */


}
